import React, { Component } from 'react'
import {
  Navbar, FormGroup, Nav, NavItem, OverlayTrigger,NavDropdown,
  MenuItem, Popover, DropdownButton, PanelGroup, Panel, Button, ButtonGroup,
} from 'react-bootstrap'
// eslint-disable-next-line max-len
import SearchAutocomplete from '../../SearchBar/components/SearchAutoComplete/SearchAutocomplete.container'
import CheckboxList from '../../../../containers/Sections/Menu/SearchMenu/checkboxList'
import MoreFilters from './moreFilters'
import * as urls from '../../../../constants/api'
import * as tel from '../../../../constants/phones'
import { translate } from 'react-translate'

import './SearchMenu.scss'

@translate('MenuSearch')
class MenuSearch extends Component {

  UNSAFE_componentWillMount(){
    this.props.didMount()
  }

  componentWillUnmount(){
    this.resetFilters()
  }

  shouldComponentUpdate(nextProps){
    if(nextProps.originPath.name != this.props.originPath.name){
      switch (nextProps.originPath.name) {
        case 'Residencial':
        // this.props.saveOriginPath({ id: '6', name: 'Residencial'})
          if(nextProps.originOffice.name != 'Puertos') {
            //this.props.retrivePropertyTypes(urls.RESIDENTIAL)
          }
          else {
            //this.props.retrivePropertyTypes(urls.PUERTOS)
          }
          if(nextProps.originOffice.name && nextProps.originOffice.name.toLowerCase() == 'nordelta'){
            this.props.retriveOperationTypes(nextProps.originOffice.name.toLowerCase())
          } else if(
            nextProps.originOffice.name && nextProps.originOffice.name.toLowerCase() == 'residencial'
          ) {
            this.props.retriveOperationTypes(nextProps.originOffice.name)
          } else {
            this.props.retriveOperationTypes(nextProps.originPath.name)
          }
          break
        case 'Locales':
        // this.props.saveOriginPath({ id: '3', name: 'Locales'})
          this.props.retriveOperationTypes(nextProps.originPath.name)
          break
        case 'Edificio':
        case 'Oficina':
        // this.props.saveOriginPath({ id: '1', name: 'Oficina'})
          this.props.retriveOperationTypes(nextProps.originPath.name)
          break
        case 'Campos':
        // this.props.saveOriginPath({ id: '9', name: 'Campos'})
          this.props.retriveOperationTypes(nextProps.originPath.name)
          break
        case 'Terrenos':
        // this.props.saveOriginPath({ id: '7', name: 'Terrenos'})
          this.props.retriveOperationTypes(nextProps.originPath.name)
          break
        case 'Industrias':
        // this.props.saveOriginPath({ id: '2', name: 'Industrias'})
          this.props.retriveOperationTypes(nextProps.originPath.name)
          break
        case 'Hoteles':
        // this.props.saveOriginPath({ id: '13', name: 'Hoteles'})
          this.props.retriveOperationTypes()
          break
        case 'Emprendimientos':
        // this.props.saveOriginPath({ id: '8', name: 'Emprendimientos'})
          this.props.retriveOperationTypes()
          break
        default:
          // this.props.saveOriginPath({ id: '', name: '/'})
          this.props.retriveOperationTypes('Residencial')
      }
    }
    return true
  }

  componentDidMount(){
      switch (this.props.originPath.name) {
        case 'Residencial':
        // this.props.saveOriginPath({ id: '6', name: 'Residencial'})
          if(this.props.originOffice.name == 'puertos') {
            this.props.setPhone(tel.TEL_PUERTOS)
          } else if(this.props.originOffice.name == 'nordelta'){
            this.props.retriveOperationTypes(this.props.originOffice.name)
            this.props.setPhone(tel.TEL_NORDELTA)
          } else if(this.props.originOffice.name == 'sanisidro') {
            this.props.retriveOperationTypes(this.props.originOffice.name)
            this.props.setPhone(tel.TEL_SANISIDRO)
          } else if(this.props.originOffice.name == 'recoleta') {
            this.props.retriveOperationTypes(this.props.originOffice.name)
            this.props.setPhone(tel.TEL_RESIDENTIAL)
          } else if(this.props.originOffice.name == 'palermo') {
            this.props.retriveOperationTypes(this.props.originOffice.name)
            this.props.setPhone(tel.TEL_PALERMO)
          } else {
            this.props.retriveOperationTypes(this.props.originPath.name)
            this.props.setPhone(tel.TEL_RESIDENTIAL)
          }
          break
        case 'Locales':
          this.props.retriveOperationTypes(this.props.originPath.name)
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Oficina':
          this.props.retriveOperationTypes(this.props.originPath.name)
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Campos':
          this.props.retriveOperationTypes(this.props.originPath.name)
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Terrenos':
          this.props.retriveOperationTypes(this.props.originPath.name)
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Industrias':
          this.props.retriveOperationTypes(this.props.originPath.name)
          this.props.setPhone(tel.TEL_INDUSTRIES)
          break
        case 'Hoteles':
          this.props.retriveOperationTypes()
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Edificios':
          this.props.retriveOperationTypes()
          this.props.setPhone(tel.TEL_HOME)
          break
        case 'Emprendimientos':
          this.props.retriveOperationTypes()
          this.props.setPhone(tel.TEL_HOME)
          break
        default:
          this.props.retriveOperationTypes('Residencial')
          this.props.setPhone(tel.TEL_HOME)
      }

      this.props.retrivePropertyTypes(urls.PROPERTIES_HOME)

  }


  constructor (props) {
    super(props)

    this.state = {
      open: false,
      moreFilters: false,
      activeKey: 0
    }
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.changeBtnView = this.changeBtnView.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

   openMenu() {
    this.setState({open: !this.state.open})
  }

  closeMenu() {
    this.setState({open: false})
    this.setState({activeKey: 0})
  }

  handleSelect(activeKey) {
    if(activeKey != this.state.activeKey){
      this.setState({ activeKey })
    } else {
      this.setState({activeKey: 0})
    }

  }

  changeBtnView() {
    this.setState({moreFilters: !this.state.moreFilters})
  }

  render(){
    const {
      min_price,
      max_price,
      currency,
      min_area,
      max_area,
      max_area_low,
      min_area_low,
      ambients,
      bathrooms,
      garages,
      bedrooms,
      naves,
      category,
      ubication,
      unit_state,
      plant_type,
      terrain,
      onChangeAreaMin,
      onChangeAreaMax,
      onChangeAreaMinLow,
      onChangeAreaMaxLow,
      onChangePriceMin,
      onChangePriceMax,
      onSelectFocus,
      originPath,
      operation_types,
      operations,
      property_types,
      property_types_loading,
      property_type,
      addOperationType,
      changeCurrency,
      onSelectTerrain,
      onSelectCategory,
      onSelectUbication,
      onSelectUnitState,
      onSelectPlant,
      focus,
      categories,
      plants,
      ubications,
      unit_states,
      terrains,
      selected_focus,
      is_professional_use,
      is_brand_new,
      resetAllFilters,
      t
    } = this.props

    let panelVisibility = !this.state.open ? 'panel-close' : 'visible-xs'

    const min_area_options = ['-',100,300,500,1000,1500,2000]
    const max_area_options = ['-',100,300,500,1000,1500,2000, '2000+']
    const min_price_options = ['-',10000,30000,500000,10000000,1500000,20000000]
    const max_price_options = ['-',10000000,300000000,5000000000,100000000,150000000,2000000000, '2000000000+']

    let otherFilters = false
    let sectorClass = ''

    //number checkbox
    const ambientsObject = { name: 'Ambientes', array: ambients, type: 'checkbox-list-numbers' }
    const roomsObject = { name: 'Dormitorios', array: bedrooms, type: 'checkbox-list-numbers'  }
    const garagesObject = { name: 'Estacionamiento', array: garages, type: 'checkbox-list-numbers'  }
    const bathroomsObject = { name: 'Baños', array: bathrooms, type: 'checkbox-list-numbers'  }
    const navesObject = { name: 'Cantidad de naves', array: naves, type: 'checkbox-list-numbers'  }

    //dropdowns
    const categoryObject =
      {name: 'Categoría', selected: category, list: categories, onSelect: onSelectCategory, type: 'dropdown'}
    const plantObject =
      {name: 'Tipo de planta', selected: plant_type, list: plants, onSelect: onSelectPlant, type: 'dropdown'}
    const focusObject =
      {name: 'Foco Comercial',selected: selected_focus, list: focus, onSelect: onSelectFocus, type: 'dropdown'}
    const terrainsObject =
      {name: 'Uso del Terreno', selected: terrain, list: terrains, onSelect: onSelectTerrain, type: 'dropdown'}
    const ubicationObject =
      {name: 'Vistas a', selected: ubication, list: ubications, onSelect: onSelectUbication, type: 'dropdown'}
    const unit_stateObject =
      {name: 'Estado', selected: unit_state, list: unit_states, onSelect: onSelectUnitState, type: 'dropdown'}

    //options checkbox
    const suitable =
      {
        name: '', options: [{name: 'Apto profesional', id: 0}],
        check: is_professional_use, type: 'checbox-list-options', array: [],
      }
    const isNewObject =
      { name: '', options: [{ name:'A estrenar', id: 0}], check: is_brand_new, type: 'checbox-list-options', array: []}

    let firstColumn = {options: [], class: ''}
    let secondColumn = {options: [], class: ''}
    let thirdColumn = {options: [], class: ''}


    //Price filter implementado con popover
    const priceFilter = (<Popover id='popover-trigger-price'>
      <div className='search-menu-filter-container'>
        {this._renderPrices(
          min_price,max_price,onChangePriceMin,onChangePriceMax,
          currency, changeCurrency,min_price_options,max_price_options,
        )}
      </div>
    </Popover>)

    //Price filter implementado con popover
    const areaFilter = (<Popover id='popover-trigger-area'>
      <div className='search-menu-filter-container'>
        {this._renderAreas(min_area,max_area,onChangeAreaMin,onChangeAreaMax,min_area_options,max_area_options)}
      </div>
    </Popover>)

    const areaDetailFilter = (<Popover id='popover-trigger-area-detail' >
      <div className='search-menu-filter-container search-menu-filter-container-wtitle'>
        <p>Superficie Total</p>
        {this._renderAreas(min_area,max_area,onChangeAreaMin,onChangeAreaMax,min_area_options,max_area_options)}
      </div>
      <div className='search-menu-filter-container search-menu-filter-container-wtitle'>
        <p>Superficie Planta Baja</p>
        {this._renderAreas(
          min_area_low,max_area_low,onChangeAreaMinLow,onChangeAreaMaxLow,min_area_options,max_area_options
        )}
      </div>
    </Popover>)

    switch (originPath.name) {
      case 'Oficina':
        firstColumn.options.push(plantObject)
        secondColumn.options.push(categoryObject)
        thirdColumn.options.push(garagesObject)
      break
      case 'Residencial':
        sectorClass = 'residential-options'
        firstColumn.options.push(ambientsObject, roomsObject, garagesObject, bathroomsObject)
        thirdColumn.options.push(suitable, isNewObject, ubicationObject, unit_stateObject)
      break
      case 'Locales':
        otherFilters = true
        secondColumn.options.push(focusObject)
      break
      case 'Terrenos':
        firstColumn.options.push(terrainsObject)
      break
      case 'Industrias':
        firstColumn.options.push(navesObject)
      break
      default:
    }

    let moreFiltersClass = ''

    if (
      (firstColumn.options.length === 0) && (secondColumn.options.length === 0) && (secondColumn.options.length === 0)
    ){
      moreFiltersClass =  'more-filters-disabled'
    }
    else if (this.state.moreFilters){
      moreFiltersClass = 'more-filters-active'
    }
    else {
      moreFiltersClass = 'more-filters-active'
    }

    let operations_title = 'Tipo de operacion'
    if (operations.length == 1) {
      let ot = operation_types && operation_types.length ? operation_types.find((op)=>op.id==operations[0].id) : []
      if (ot) operations_title = ot.name
    }

    let property_types_title = 'Tipo de propiedad'
    if (property_type.length == 1) {
      let ot = property_types.find((pt)=>pt.id==property_type[0].id)
      if (ot) property_types_title = ot.name
    }

    return (
        <div id='menu' className={'navbar-menu-buscador' + ' ' + sectorClass }>
          <Navbar inverse>
          {/*<---- MOBILE --->*/}
            <NavItem className='auto-search visible-xs'>
              <ButtonGroup className='search-bar'>
                <SearchAutocomplete />
                <Button type='submit' className='btn-primary btn-search' id='btn-search'>
                  <i className='fa fa-search' aria-hidden='true'></i>
                </Button>
              </ButtonGroup>
            </NavItem>
            <div className='responsive-filters-menu visible-xs'>
              <Button
                className={
                  'btn-menu-buscar' + (this.state.open ? ' button-active' : ' button-close')}
                onClick={this.openMenu}
              >
                {t('Filtros')}
              </Button>
            </div>
            <PanelGroup
              className={panelVisibility}
              accordion
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              <Panel eventKey='0.1'>
                <Panel.Heading>
                  <Panel.Title className='text-center' toggle>Tipo de operación</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  {operation_types && operation_types.map((item, index) =>
                    <MenuItem
                      className={
                        (operations.length == 1 && operations[0].id === item.id) ? 'active-item subitem' : 'subitem'
                      }
                      eventKey={index}
                      key={index}
                      onSelect={() => this.addOperationType(item)} onClick={this.closeMenu}
                    >
                      {item.name}
                    </MenuItem>
                  )}
                  <MenuItem
                    className={(operations.length > 1) ? 'active-item' : ''}
                    onSelect={() => addOperationType(operation_types)}
                  >
                    Todas
                  </MenuItem>
                </Panel.Body>
              </Panel>
              <Panel eventKey='0.2'>
                <Panel.Heading>
                  <Panel.Title className='text-center' toggle>Tipo de propiedad</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  {property_types.map((item, index) =>
                    <MenuItem
                      className={((property_type.length > 0) && (property_type[0].id === item.id)) ? 'active-item' : ''}
                      eventKey={index}
                      key={index}
                      onSelect={() => this.updateSectorPropertyType(item)}
                    >
                      {item.name}
                    </MenuItem>
                  )}
                </Panel.Body>
              </Panel>
              <Panel eventKey='0.3' className='select-row-search'>
                <Panel.Heading>
                  <Panel.Title className='text-center' className='text-center' toggle>Precio</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  {this._renderPrices(
                    min_price,max_price,onChangePriceMin,onChangePriceMax,
                    currency, changeCurrency,min_price_options,max_price_options,
                  )}
                </Panel.Body>
              </Panel>
              {(!otherFilters) ? (
                <Panel eventKey='0.4'>
                  <Panel.Heading>
                    <Panel.Title className='text-center' toggle>Superficie</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    {this._renderAreas(
                      min_area,max_area,onChangeAreaMin,onChangeAreaMax,
                      min_area_options,max_area_options,
                    )}
                  </Panel.Body>
                </Panel>) : null
              }
              {(!otherFilters) ? (
                <Panel eventKey='0.41'>
                  <Panel.Heading>
                    <Panel.Title className='text-center' toggle>Superficie Total</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    {this._renderAreas(
                      min_area,max_area,onChangeAreaMin,onChangeAreaMax,
                      min_area_options,max_area_options
                    )}
                  </Panel.Body>
                </Panel>) : null
              }
              {(!otherFilters) ? (
                <Panel eventKey='0.42'>
                  <Panel.Heading>
                    <Panel.Title className='text-center' toggle>Superficie planta baja</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    {this._renderAreas(
                      min_area_low,max_area_low,onChangeAreaMinLow,
                      onChangeAreaMaxLow,min_area_options,max_area_options
                    )}
                  </Panel.Body>
                </Panel>) : null
              }
              {(sectorClass) ? (
                <Panel eventKey='0.5'>
                  <Panel.Heading>
                    <Panel.Title className='text-center' toggle>Ambientes</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <FormGroup>
                      <CheckboxList key='1' array={ambients} item={ambientsObject}/>
                    </FormGroup>
                  </Panel.Body>
                </Panel>) : null
              }
              {(sectorClass) ? (
                <Panel eventKey='0.6'>
                  <Panel.Heading>
                    <Panel.Title className='text-center' toggle>Dormitorios</Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <FormGroup>
                      <CheckboxList key='2' array={bedrooms} item={roomsObject}/>
                    </FormGroup>
                  </Panel.Body>
                </Panel>) : null
              }
              <Panel eventKey='0.7' className={'dropdown-more-filters' + ' ' + moreFiltersClass}>
                <Panel.Heading>
                  <Panel.Title className='text-center' toggle>Más filtros</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <MoreFilters first={firstColumn} second={secondColumn} third={thirdColumn} />
                </Panel.Body>
              </Panel>
            </PanelGroup>
          {/*<---- END MOBILE --->*/}
            <Navbar.Toggle />
            <Navbar.Collapse>
              <Nav>
                <NavDropdown title={operations_title} id='nav-tipo-op'>
                  <FormGroup className='form-selects'>
                    {operation_types && operation_types.map((item, index) =>
                      <MenuItem
                        className={(operations.length ==1 && operations[0].id === item.id) ? 'active-item' : ''}
                        eventKey={index}
                        key={index}
                        onSelect={() => addOperationType(item)}
                      >
                        {item.name}
                      </MenuItem>
                    )}
                    <MenuItem
                      className={(operations.length > 1) ? 'active-item' : ''}
                      onSelect={() => addOperationType(operation_types)}
                    >
                      Todas
                    </MenuItem>
                  </FormGroup>
                </NavDropdown>
                <NavDropdown
                  title={<h1 className='current-filter-value'>{property_types_title}</h1>} id='nav-tipo-prop'
                >
                  {property_types_loading?'Cargando...':
                    (<FormGroup className='form-selects'>
                      {property_types.map((item, index) =>
                        <MenuItem
                          className={
                            ((property_type.length > 0) && (property_type[0].id === item.id)) ? 'active-item' : ''
                          }
                          eventKey={index}
                          key={index}
                          onSelect={() => this.updateSectorPropertyType(item)}
                        >
                          {item.name}
                        </MenuItem>
                      )}
                    </FormGroup>)
                  }
                </NavDropdown>
                <NavItem className='auto-search hidden-xs'>
                  <SearchAutocomplete />
                </NavItem>
              </Nav>
               <Nav pullRight>
                <NavItem>
                  <OverlayTrigger trigger='click' placement='bottom' overlay={priceFilter} rootClose={true}>
                    <a
                      id='nav-prices'
                      role='button'
                      className='dropdown-toggle'
                      aria-haspopup='true'
                      aria-expanded='false'
                      href='#'
                    >
                      Precio<span className='caret'></span>
                    </a>
                  </OverlayTrigger>
                </NavItem>
                { (!otherFilters) ? (
                <NavItem>
                  <OverlayTrigger trigger='click' placement='bottom' overlay={areaFilter} rootClose={true}>
                    <a
                      id='nav-areas'
                      role='button'
                      className='dropdown-toggle'
                      aria-haspopup='true'
                      aria-expanded='false'
                      href='#'
                    >
                      Superficie<span className='caret'></span>
                    </a>
                  </OverlayTrigger>
                </NavItem>
                ):''}
                { (sectorClass) ? (
                  <React.Fragment>
                    <NavDropdown
                      id='nav-areas' title='Ambientes' className='hiddenTablet hidden-md dropdown-ambients hidden-xs'
                    >
                      <FormGroup>
                        <CheckboxList key='1' array={ambients} item={ambientsObject}/>
                      </FormGroup>
                    </NavDropdown>
                    <NavDropdown
                      id='nav-areas' title='Dormitorios' className='hidden-md hiddenTablet dropdown-rooms hidden-xs'
                    >
                      <FormGroup>
                        <CheckboxList key='2' array={bedrooms} item={roomsObject}/>
                      </FormGroup>
                    </NavDropdown>
                  </React.Fragment> ) : ''
                 }
                <NavDropdown
                  id='nav-areas'
                  title='Más filtros'
                  className={'dropdown-more-filters hidden-xs' + ' ' + moreFiltersClass} onClick={this.changeBtnView}
                >
                  <MoreFilters first={firstColumn} second={secondColumn} third={thirdColumn} />
                </NavDropdown>
                <NavItem>
                  <Button className='btn-icons' onClick={resetAllFilters}>
                    <i className='fa fa-trash fa-lg' aria-hidden='true'></i>
                  </Button>
                </NavItem>
                </Nav>
              <Nav>
                { (otherFilters) ? (
                  <NavItem>
                    <OverlayTrigger
                      trigger='click'
                      placement='bottom'
                      overlay={areaDetailFilter}
                      rootClose={true}
                      className='dropdown-areas hidden-xs'
                    >
                      <a
                        id='nav-areas'
                        role='button'
                        className='dropdown-toggle'
                        aria-haspopup='true'
                        aria-expanded='false'
                        href='#'
                      >
                        Superficie<span className='caret'></span>
                      </a>
                    </OverlayTrigger>
                  </NavItem>
                ) : ''}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>

    )
  }

  _checkStatus(array, item){
    for (var i in array){
      if(array[i].id === item.id){
        return true
      }
    }
  }

  _checkFiltersStatues(array, n) {
    for (var i in array){
      if(array[i] === n){
        return true
      }
    }
  }

  _renderPrices(
    min_price,max_price,onChangePriceMin,onChangePriceMax, currency, changeCurrency
  ) {
    let minPrice = (min_price !== '') ? min_price : 'Desde'
    let maxPrice = (max_price !== '') ? max_price : 'Hasta'
    let c = (currency === 5) ? 'U$S' : 'AR$'
    if(currency === 5) c = 'U$S'
    else if (currency === 4) c = 'AR$'
    else c = '-'

    return (
      <div className='prices-search-menu'>
        <input type='number' placeholder={minPrice} min='0' onChange={onChangePriceMin}></input>
        <input type='number' placeholder={maxPrice} min='0' onChange={onChangePriceMax}></input>
         <DropdownButton title={c} id='dropdown-small' onSelect={ changeCurrency } className='currency-selector'>
            <MenuItem eventKey={null}> - </MenuItem>
            <MenuItem eventKey={4}>AR$</MenuItem>
            <MenuItem eventKey={5}>U$S</MenuItem>
        </DropdownButton>
      </div>
    )
  }

  _renderAreas(min_area,max_area,onChangeAreaMin,onChangeAreaMax) {
    let minArea = (min_area !== '') ? min_area : 'Desde'
    let maxArea = (max_area !== '') ? max_area : 'Hasta'
    return (
      <div className='areas-search-menu'>
        <input type='number' placeholder={minArea} min='0' onChange={onChangeAreaMin}></input>
        <input type='number' placeholder={maxArea} min='0' onChange={onChangeAreaMax}></input>
      </div>
    )
  }

  /**
   * [updateSectorPropertyType description]
   * Esta función sirve para que cuando se seleccione un item del
     select de tipo de propiedad y es un sector distinto al
     de la vigente búsqueda cambie los filtros a los del
     nuevo sector y además actualice las opciones.
   * @param  {object} item es una opción de tipo de propiedad
   * @return {void}
   */
  updateSectorPropertyType(item){
    //en función del nombre del item vamos a salvar el origin
    //y actualizar las opciones del select de tipo de propiedad
    let section = item.name.toLowerCase()
    switch (section) {
      case 'departamento':
      case 'casa':
      case 'casa en barrio cerrado':
      case 'terreno en barrio cerrado':
      case 'vivienda':
        this.props.saveOriginPath({ id: '6', name: 'Residencial'})
        this.props.setPhone(tel.TEL_RESIDENTIAL)
        break
      case 'local':
        this.props.saveOriginPath({ id: '3', name: 'Locales'})
        this.props.setPhone(tel.TEL_HOME)
        break
      case 'oficina':
      case 'edificio':
        this.props.saveOriginPath({ id: '1', name: 'Oficina'})
        this.props.setPhone(tel.TEL_HOME)
        break
      case 'campo':
        this.props.saveOriginPath({ id: '9', name: 'Campos'})
        this.props.setPhone(tel.TEL_HOME)
        break
      case 'terreno':
        this.props.saveOriginPath({ id: '7', name: 'Terrenos'})
        this.props.setPhone(tel.TEL_HOME)
        break
      case 'industria':
        this.props.saveOriginPath({ id: '2', name: 'Industrias'})
        this.props.setPhone(tel.TEL_INDUSTRIES)
        break
      case 'hotel':
        this.props.saveOriginPath({ id: '13', name: 'Hoteles'})
        this.props.setPhone(tel.TEL_HOME)
        break
      case 'emprendimiento':
        this.props.saveOriginPath({ id: '8', name: 'Emprendimientos'})
        this.props.setPhone(tel.TEL_HOME)
        break
      default:
        this.props.saveOriginPath({ id: '', name: '/'})
        this.props.setPhone(tel.TEL_HOME)

        this.props.retrivePropertyTypes(urls.PROPERTIES_HOME)

    }

    //reseteo el emprendimiento por si está seteado.
    this.props.resetEntrepreneurshipId()

    //Resetear filtros
    if(this.props.sub_departamento_type.length){
      this.resetFilters()
    }
    //actualizo la property type seleccionada
    // esta acción también dispara la búsqueda
    this.props.addPropertyType(item)

  }

  /**
   * [resetFilters [Resetear los filtros]]
   */
  resetFilters(){
    this.props.resetSubDepartamentoType()
    this.props.resetSubPropertyType()
  }

  /**
   * updateSubPropertyType [Es para actualizar el subtipo de propiedad]
   * @param  {[type]} item [item seleccionado]
   */
  updateSubPropertyType(item) {
    if(this.props.sub_departamento_type.length){
      this.resetFilters()
    }
    this.props.addSubPropertyType(item)
  }
}

export default MenuSearch



// WEBPACK FOOTER //
// ./src/features/commons/Menu/SearchMenu/index.js